import {Injectable} from '@angular/core';
import {DatePipe} from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class DateService {

  constructor(private datePipe: DatePipe) {
  }

  getYearMonthDayUsingUTC(date: Date): string {
    return date.toISOString().substring(0, 10);
  }

  getMediumDate(date: Date | number): string | null {
    return this.datePipe.transform(date, 'medium');
  }

  getMediumTime(date: string | number): string | null {
    return this.datePipe.transform(date, 'mediumTime');
  }
}
